<template>
  <v-container class="pa-0 ma-0">
    <v-dialog v-model="tospp"
      hide-overlay
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
      >
      <app-tos-pp
        @dismissed="onDismissed"
        :dialog='tospp'
        :type='type'>
      </app-tos-pp>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      type: 'pp',
      tospp: true
    }
  },
  methods: {
    onDismissed: function (result) {
      this.tospp = false
    }
  }
}
</script>

<style>
</style>
